var a = {};
export {
  a as __exports
};
//# sourceMappingURL=index.es481.js.map
